import Spinner from "../spinner/spinner";
import { ClassNameSpinner } from "../spinner/types/spinnerProps";
import { SummaryProps } from "./types/summaryProps";
import "./summary.scss";

const Summary = (props: SummaryProps) => {
    return (
        props.loading ?
            <Spinner text="Anulowanie zadań" spinnerClass={ClassNameSpinner.Big} /> :
            <div className="body-txt-large cancelTask-summary">
                <div>Podsumowanie:</div>
                <div>{props.summary?.info}</div>
                {props.summary?.errors && <div className="body-txt-large cancelTask-summary cancelTask-summary-error">
                    <div>Błędy operacji:</div>
                    {props.summary.errors.map((e, idx) => {
                        return <div key={idx}>{e}</div>
                    })}
                </div>}
            </div>
    )
}

export default Summary;
